/**
 * Client-side fallback (preview); productie gebruikt bootstrap uit opening-hours.php.
 */
export function getOpeningHoursState(date = new Date()) {
  let label = 'Vandaag geopend!';
  let beesd = '07:00 - 17:00';
  let culemborg = '08:00 - 17:00';

  const wk = date.getDay();
  const currentWeek = getIsoWeek(date);
  const currentMonth = date.getMonth() + 1;
  const currentDay = date.getDate();

  const isChristmasPeriod = currentMonth === 12 && currentDay >= 24 && currentDay <= 26;
  const isNewYearPeriod =
    (currentMonth === 12 && currentDay === 31) || (currentMonth === 1 && currentDay === 1);
  const isEasterSecondDayPeriod = currentMonth === 4 && currentDay === 6;
  const isEasterAnnouncement = currentMonth === 4 && currentDay >= 2 && currentDay <= 6;
  const isKingsdayPeriod = currentMonth === 4 && currentDay === 27;
  const isAscensionPeriod = currentMonth === 5 && currentDay === 14;
  const isAscensionAnnouncement = currentMonth === 5 && currentDay >= 11 && currentDay <= 14;
  const isPentecostPeriod = currentMonth === 5 && currentDay === 25;

  if (isKingsdayPeriod) {
    label = 'Vandaag gesloten i.v.m. Koningsdag';
    beesd = 'Gesloten';
    culemborg = 'Gesloten';
  } else if (isEasterSecondDayPeriod) {
    label = 'a.s. maandag 6 april: gesloten (2e Paasdag)';
    beesd = 'Gesloten';
    culemborg = 'Gesloten';
  } else if (isAscensionPeriod) {
    label = 'Vandaag gesloten i.v.m. Hemelvaartsdag';
    beesd = 'Gesloten';
    culemborg = 'Gesloten';
  } else if (isPentecostPeriod) {
    label = 'Vandaag gesloten i.v.m. 2e Pinksterdag';
    beesd = 'Gesloten';
    culemborg = 'Gesloten';
  } else if (isChristmasPeriod) {
    if (currentDay === 24) {
      label = 'Aangepaste openingstijden';
      beesd = '07:00 - 12:00';
      culemborg = '08:00 - 12:00';
    } else {
      label = 'Gesloten i.v.m. kerst';
      beesd = 'Gesloten';
      culemborg = 'Gesloten';
    }
  } else if (isNewYearPeriod) {
    if (currentDay === 31 && currentMonth === 12) {
      label = 'Aangepaste openingstijden';
      beesd = '07:00 - 12:00';
      culemborg = '08:00 - 12:00';
    } else {
      label = 'Gesloten i.v.m. nieuwjaar';
      beesd = 'Gesloten';
      culemborg = 'Gesloten';
    }
  } else if (String(currentWeek) === '33') {
    beesd = 'Deze week gesloten';
  } else {
    if (wk === 0) {
      label = 'Zondag gesloten';
      beesd = 'Maandag 08:00 - 17:00';
      culemborg = 'Maandag 08:00 - 17:00';
    }
    if (wk === 6) {
      beesd = '08:00 - 12:30';
      culemborg = '08:00 - 15:00';
    }
  }

  let announcement = '';
  if (!isEasterSecondDayPeriod && isEasterAnnouncement) {
    announcement = '(a.s. maandag 6 april gesloten)';
  }
  if (!isAscensionPeriod && isAscensionAnnouncement) {
    announcement = '(a.s. donderdag 14 mei gesloten)';
  }

  return {
    label,
    beesd,
    culemborg,
    announcement,
    phoneHours: 'Ma – Vr 07:00 – 17:00'
  };
}

function getIsoWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}
